import { gql } from '@/__generated__';

/**
 * `code`/`message` describen el resultado real de la detención (AMARU-862/US-003): `GO00` se
 * detuvo, `GO04` no había movimiento, `LEGACY_OK` comando enviado sin confirmación.
 * `queuedRequestCancellation` es aparte: qué pasó con la solicitud en cola que el stop también
 * cancela (SGMO-14), en cualquiera de esos desenlaces.
 */
export const STOP_GATE_OPERATION = gql(`#graphql
  mutation StopGateOperation($gateId: ID!) {
    stopGateOperation(input: { gateId: $gateId }) {
      success
      code
      message
      queuedRequestCancellation
    }
  }
`);
